<section class="surface-elevated p-6 sm:p-8" style="opacity: 1; transform: none;">
    <h2 class="mb-6 flex items-center gap-2 text-2xl font-semibold text-text-primary">
        <i class="fas" [ngClass]="expert.type === 'developer' ? 'fa-city text-primary' : 'fa-chart-line text-primary'"></i>
        {{ (expert.type === 'developer' ? 'experts.deals.latestCompletedProjects' : 'experts.deals.latestSuccessfulDeals') | translate }}
    </h2>
    <div class="space-y-3">
        <div class="rounded-lg border border-border-subtle bg-surface p-4 text-center text-sm text-text-muted">
            {{ 'experts.deals.noDetails' | translate }}
        </div>
    </div>
</section>
